module.exports = __webpack_public_path__ + "static/grafika7@2x-b65c7b2f29462012cec399cc7290b82e.png";